<div class="property-control" [class.compact]="compact">
  <!-- Rótulo da Propriedade -->
  <div class="property-label">
    <label [for]="property + '-input'">
      {{ displayName |translateTA }}
      <span class="required-indicator" *ngIf="property === 'required' && control.value">*</span>
    </label>
    
    <!-- Ícone de Ajuda -->
    <nz-icon
      *ngIf="getHelpText()"
      nzType="question-circle"
      nzTheme="outline"
      [nz-tooltip]="getHelpText()"
      class="help-icon">
    </nz-icon>
  </div>

  <!-- Controles de Input de Propriedades -->
  <div class="property-input">
          <!-- Input de Texto -->
    <input
      *ngIf="propertyType === 'text'"
      nz-input
      [id]="property + '-input'"
      [formControl]="control"
      [placeholder]="getInputPlaceholder()"
      [nzSize]="compact ? 'small' : 'default'">

          <!-- Input de Área de Texto -->
    <textarea
      *ngIf="propertyType === 'textarea'"
      nz-input
      [id]="property + '-input'"
      [formControl]="control"
      [placeholder]="getInputPlaceholder()"
      [nzAutosize]="{ minRows: 2, maxRows: 4 }"
      [nzSize]="compact ? 'small' : 'default'">
    </textarea>

          <!-- Input Numérico -->
    <nz-input-number
      *ngIf="propertyType === 'number'"
      [id]="property + '-input'"
      [formControl]="control"
      [nzPlaceHolder]="getInputPlaceholder()"
      [nzSize]="compact ? 'small' : 'default'"
      [nzMin]="getNumberMin()"
      [nzMax]="getNumberMax()"
      [nzStep]="getNumberStep()"
      style="width: 100%">
    </nz-input-number>

          <!-- Switch Booleano -->
    <nz-switch
      *ngIf="propertyType === 'boolean'"
      [id]="property + '-input'"
      [formControl]="control"
      [nzSize]="compact ? 'small' : 'default'">
    </nz-switch>

          <!-- Dropdown de Seleção -->
    <nz-select
      *ngIf="propertyType === 'select'"
      [id]="property + '-input'"
      [formControl]="control"
      [nzPlaceHolder]="getInputPlaceholder()"
      [nzSize]="compact ? 'small' : 'default'"
      style="width: 100%">
      <nz-option
        *ngFor="let option of selectOptions"
        [nzValue]="option.value"
        [nzLabel]="option.label">
      </nz-option>
    </nz-select>

          <!-- Seletor de Cor -->
    <div *ngIf="propertyType === 'color'" class="color-input-group">
      <nz-color-picker
        [id]="property + '-input'"
        [formControl]="control"
        [nzSize]="compact ? 'small' : 'default'"
        nzShowText>
      </nz-color-picker>
      
              <!-- Prévia da Cor -->
      <div
        class="color-preview"
        [style.background-color]="control.value"
        [title]="control.value">
      </div>
      
              <!-- Reset Rápido de Cor -->
      <button
        nz-button
        nzType="text"
        nzSize="small"
        (click)="control.setValue('#ffffff')"
        nz-tooltip="Reset to white"
        class="color-reset">
        <nz-icon nzType="reload" nzTheme="outline"></nz-icon>
      </button>
    </div>
  </div>

  <!-- Descrição da Propriedade -->
  <div class="property-description" *ngIf="description && !compact">
    <small>{{ description }}</small>
  </div>

  <!-- Mensagens de Validação -->
  <div class="property-validation" *ngIf="control.invalid && control.touched">
    <small class="error-message">
      <nz-icon nzType="exclamation-circle" nzTheme="fill"></nz-icon>
      {{ getValidationMessage() }}
    </small>
  </div>
</div>
